/* eslint-disable */
// prettier-ignore
import * as Types from '../../../graphql/__generated__/index';

import { gql } from '@apollo/client';
import { CollectionSegmentInfoPartsFragmentDoc } from './commonFragments';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Common_CountryPartsFragment = {
  __typename?: 'EnumLabelOfCountry';
  id: Types.Country;
  displayName: string;
  region?: { __typename?: 'EnumLabelOfRegion'; id: Types.Region; displayName: string } | null;
};

export type Common_ExchangeMicPartsFragment = {
  __typename?: 'EnumLabelOfOfferingSetupExchangeMic';
  id: Types.OfferingSetupExchangeMic;
  displayName: string;
};

export type Common_SectorPartsFragment = {
  __typename?: 'EnumLabelOfSector';
  id: Types.Sector;
  displayName: string;
};

export type Common_CustomSectorPartsFragment = {
  __typename?: 'CustomSector';
  id: string;
  name?: string | null;
};

export type Common_OfferingTypePartsFragment = {
  __typename?: 'EnumLabelOfOfferingType';
  id: Types.OfferingType;
  displayName: string;
};

export type Common_OfferingStatusPartsFragment = {
  __typename?: 'EnumLabelOfOfferingStatus';
  id: Types.OfferingStatus;
  displayName: string;
};

export type Common_FilterOptionsQueryVariables = Types.Exact<{
  hasCustomSectorsPermission: Types.Scalars['Boolean'];
}>;

export type Common_FilterOptionsQuery = {
  __typename?: 'Query';
  countries?: {
    __typename?: 'CountriesCollectionSegment';
    items?: Array<{
      __typename?: 'EnumLabelOfCountry';
      id: Types.Country;
      displayName: string;
      region?: { __typename?: 'EnumLabelOfRegion'; id: Types.Region; displayName: string } | null;
    }> | null;
    pageInfo: {
      __typename?: 'CollectionSegmentInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
  offeringSetupExchangeMics?: {
    __typename?: 'OfferingSetupExchangeMicsCollectionSegment';
    items?: Array<{
      __typename?: 'EnumLabelOfOfferingSetupExchangeMic';
      id: Types.OfferingSetupExchangeMic;
      displayName: string;
    }> | null;
    pageInfo: {
      __typename?: 'CollectionSegmentInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
  sectors?: {
    __typename?: 'SectorsCollectionSegment';
    items?: Array<{
      __typename?: 'EnumLabelOfSector';
      id: Types.Sector;
      displayName: string;
    }> | null;
    pageInfo: {
      __typename?: 'CollectionSegmentInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
  customSectors?: {
    __typename?: 'CustomSectorCollectionSegment';
    items?: Array<{ __typename?: 'CustomSector'; id: string; name?: string | null }> | null;
    pageInfo: {
      __typename?: 'CollectionSegmentInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
  offeringTypes?: {
    __typename?: 'OfferingTypesCollectionSegment';
    items?: Array<{
      __typename?: 'EnumLabelOfOfferingType';
      id: Types.OfferingType;
      displayName: string;
    }> | null;
  } | null;
  offeringStatuses?: {
    __typename?: 'OfferingStatusesCollectionSegment';
    items?: Array<{
      __typename?: 'EnumLabelOfOfferingStatus';
      id: Types.OfferingStatus;
      displayName: string;
    }> | null;
  } | null;
};

export const Common_CountryPartsFragmentDoc = gql`
  fragment Common_CountryParts on EnumLabelOfCountry {
    id
    displayName
    region {
      id
      displayName
    }
  }
`;
export const Common_ExchangeMicPartsFragmentDoc = gql`
  fragment Common_ExchangeMicParts on EnumLabelOfOfferingSetupExchangeMic {
    id
    displayName
  }
`;
export const Common_SectorPartsFragmentDoc = gql`
  fragment Common_SectorParts on EnumLabelOfSector {
    id
    displayName
  }
`;
export const Common_CustomSectorPartsFragmentDoc = gql`
  fragment Common_CustomSectorParts on CustomSector {
    id
    name
  }
`;
export const Common_OfferingTypePartsFragmentDoc = gql`
  fragment Common_OfferingTypeParts on EnumLabelOfOfferingType {
    id
    displayName
  }
`;
export const Common_OfferingStatusPartsFragmentDoc = gql`
  fragment Common_OfferingStatusParts on EnumLabelOfOfferingStatus {
    id
    displayName
  }
`;
export const Common_FilterOptionsDocument = gql`
  query Common_FilterOptions($hasCustomSectorsPermission: Boolean!) {
    countries {
      items {
        ...Common_CountryParts
      }
      pageInfo {
        ...CollectionSegmentInfoParts
      }
    }
    offeringSetupExchangeMics {
      items {
        ...Common_ExchangeMicParts
      }
      pageInfo {
        ...CollectionSegmentInfoParts
      }
    }
    sectors {
      items {
        ...Common_SectorParts
      }
      pageInfo {
        ...CollectionSegmentInfoParts
      }
    }
    customSectors @include(if: $hasCustomSectorsPermission) {
      items {
        ...Common_CustomSectorParts
      }
      pageInfo {
        ...CollectionSegmentInfoParts
      }
    }
    offeringTypes {
      items {
        ...Common_OfferingTypeParts
      }
    }
    offeringStatuses {
      items {
        ...Common_OfferingStatusParts
      }
    }
  }
  ${Common_CountryPartsFragmentDoc}
  ${CollectionSegmentInfoPartsFragmentDoc}
  ${Common_ExchangeMicPartsFragmentDoc}
  ${Common_SectorPartsFragmentDoc}
  ${Common_CustomSectorPartsFragmentDoc}
  ${Common_OfferingTypePartsFragmentDoc}
  ${Common_OfferingStatusPartsFragmentDoc}
`;

/**
 * __useCommon_FilterOptionsQuery__
 *
 * To run a query within a React component, call `useCommon_FilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommon_FilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommon_FilterOptionsQuery({
 *   variables: {
 *      hasCustomSectorsPermission: // value for 'hasCustomSectorsPermission'
 *   },
 * });
 */
export function useCommon_FilterOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Common_FilterOptionsQuery,
    Common_FilterOptionsQueryVariables
  > &
    ({ variables: Common_FilterOptionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Common_FilterOptionsQuery, Common_FilterOptionsQueryVariables>(
    Common_FilterOptionsDocument,
    options
  );
}
export function useCommon_FilterOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Common_FilterOptionsQuery,
    Common_FilterOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Common_FilterOptionsQuery, Common_FilterOptionsQueryVariables>(
    Common_FilterOptionsDocument,
    options
  );
}
export function useCommon_FilterOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Common_FilterOptionsQuery, Common_FilterOptionsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Common_FilterOptionsQuery, Common_FilterOptionsQueryVariables>(
    Common_FilterOptionsDocument,
    options
  );
}
export type Common_FilterOptionsQueryHookResult = ReturnType<typeof useCommon_FilterOptionsQuery>;
export type Common_FilterOptionsLazyQueryHookResult = ReturnType<
  typeof useCommon_FilterOptionsLazyQuery
>;
export type Common_FilterOptionsSuspenseQueryHookResult = ReturnType<
  typeof useCommon_FilterOptionsSuspenseQuery
>;
export type Common_FilterOptionsQueryResult = Apollo.QueryResult<
  Common_FilterOptionsQuery,
  Common_FilterOptionsQueryVariables
>;
